import React from "react";
import { useTranslation } from "react-i18next";

export default function Cookies() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      
      <h1>{t("cookies.title")}</h1>
      <p>{t("cookies.last_updated")}</p>

      <h2>{t("cookies.sections.what_are_cookies.title")}</h2>
      <p>{t("cookies.sections.what_are_cookies.text")}</p>

      <h2>{t("cookies.sections.our_use.title")}</h2>
      <p>{t("cookies.sections.our_use.text")}</p>

      <h2>{t("cookies.sections.future_use.title")}</h2>
      <p>{t("cookies.sections.future_use.text")}</p>

      <h2>{t("cookies.sections.third_party.title")}</h2>
      <p>{t("cookies.sections.third_party.text")}</p>

      <h2>{t("cookies.sections.contact.title")}</h2>
      <p>{t("cookies.sections.contact.text")}</p>

    </div>
  );
}